// client/src/lib/safeFetch.js
export async function safeFetch(url, opts = {}) {
  const res = await fetch(url, opts);
  let body = null;
  try { body = await res.json(); } catch {}
  if (!res.ok) {
    const msg = body?.message || body?.error || res.statusText || "Request failed";
    const err = new Error(msg);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body ?? {};
}
